import { get, patch, post, put, upload } from "Service";

const CorporateList = (payload: any) => {
    console.log("payload", payload);
    const request = {
        subUrl: `Admin/GetAllUnverifiedCorporateUser?userType=${payload.userType}`,
        data: payload,
        isAuth: false,
    };
    return get(request);
}

const ProfessionalList = () => {
    const request = {
        subUrl: "Admin/GetAllUnverifiedProfessionalUser",
        isAuth: false,
    };
    return get(request);
}

const VerifyCorporate = (payload: any) => {
    const request = {
        subUrl: "Admin/verify-user",
        data: payload,
        isAuth: false,
    };
    return post(request);
}
const VerifyProfessional = (payload: any) => {
    const request = {
        subUrl: "Admin/verify-user",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const fetchCases = async () => {
    try {
        const request = {
            subUrl: "Admin/getAllCases",
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching cases:", error);
        throw error;
    }
}
const fetchVerifyProfessionalList = async () => {
    try {
        const request = {
            subUrl: "Admin/getAllVerifiedProfessional",
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching professional list:", error);
        throw error;
    }
}

const AssignCaseToProfessional = async (payload: any) => {
    try {
        const request = {
            subUrl: "Admin/assign-professional",
            data: payload,
            isAuth: false,
        };
        return await post(request);
    } catch (error) {
        console.error("Error assigning case to professional:", error);
        throw error;
    }
}

const OrderHistory = async (id : string) => {
    try {
        const request = {
            subUrl: `Cases/user/${id}`,
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching order history:", error);
        throw error;
    }
}

const getProfile = (userId: string) => {
    const request = {
        subUrl: `get-user/${userId}`,
        isAuth: true,
    };
    return get(request);
}   

const ProfileUpdate = (userId: string, payload: any, userType: string) => {
     const formattedUserType =
    userType.charAt(0).toUpperCase() + userType.slice(1).toLowerCase();
    const request = {
        subUrl: `update-user/${userId}?userType=${formattedUserType}`,
        data: payload,
        isAuth: true,
    };
    return post(request);
}

const UploadProfilePicture = (file: File, userId: string) => {
     const fd = new FormData();
  fd.append("file", file, file.name);
    const request = {
        subUrl: `${userId}/upload-profile-picture`,
        data: fd,
        isAuth: true,
    };
    return upload(request);
}

const HotlineList = () => {
    const request = {
        subUrl: "Hotline",
        isAuth: false,
    };
    return get(request);
}

const CreateHotline = (payload: any) => {
    const request = {
        subUrl: "Hotline",
        data: payload,
        isAuth: false,
    };
    return post(request);
}
const sendPaymentLink = (payload: any) => {
    const request = {
        subUrl: "Hotline/send-payment-link",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const GetAllActiveProfessionalUser = () => {
    const request = {
        subUrl: "Admin/GetAllActiveProfessionalUser",
        isAuth: false,
    };
    return get(request);
}

const getAllUnAssignedProfessionalCases = () => {
    const request = {
        subUrl: "Admin/getAllUnAssignedProfessionalCases",
        isAuth: false,
    };
    return get(request);
}

const fetchCaseDetails = async (caseId: Number) => {
    try {
        const request = {
            subUrl: `Cases/${caseId}`,
            isAuth: false,
        };
        return await get(request);
    } catch (error) {
        console.error("Error fetching case details:", error);
        throw error;
    }
};

const CreateAdminUser = (payload: any) => {
    const request = {
        subUrl: "Admin/create",
        data: payload,
        isAuth: false,
    };
    return post(request);
}

const UpdateAdminUser = (id: number | string, payload: any) => {
  const request = {
    subUrl: `Admin/update/${id}`,
    data: payload,
    isAuth: false,
  };
  return put(request);
};

const getAllAdminUsers = () => {
    const request = {
        subUrl: "Admin",
        isAuth: false,
    };
    return get(request);
}

const getAllCasesWithAssignedAdminProfessional = () => {
    const request = {
        subUrl: "Admin/getAllCasesWithAssignedAdminProfessional",
        isAuth: false,
    };
    return get(request);
}

const updateCaseAssignment = (caseId: number | string, payload: any ) => {
    const request = {
        subUrl: `Admin/updateCaseAssignment/${caseId}`,
        isAuth: false,
        data: payload,
    };
    return put(request);
}

const RefundRequest = ( payload: any ) => {
    const request = {
        subUrl: "RefundRequest",
        isAuth: false,
        data: payload,
    };
    return post(request);
}

const getRefundRequest = ( ) => {
    const request = {
        subUrl: `RefundRequest/admin-requests`,
        isAuth: false,
    };
    return get(request);
}

const getAllUsers = () => {
    const request = {
        subUrl: "Admin/users",
        isAuth: false,
    };
    return get(request);
}

const updateUserVerifiedStatus = (payload: any) => {
    const request = {
        subUrl: "Admin/update-user-verified-status",
        isAuth: false,
        data: payload,
    };
    return put(request);
}



const AdminApi = {
    CorporateList,
    VerifyCorporate,
    VerifyProfessional,
    ProfessionalList,
    fetchVerifyProfessionalList,
    AssignCaseToProfessional,
    fetchCases,
    OrderHistory,
    getProfile,
    ProfileUpdate,
    UploadProfilePicture,
    HotlineList,
    CreateHotline,
    sendPaymentLink,
    GetAllActiveProfessionalUser,
    fetchCaseDetails,
    getAllUnAssignedProfessionalCases,
    CreateAdminUser,
    UpdateAdminUser,
    getAllAdminUsers,
    getAllCasesWithAssignedAdminProfessional,
    updateCaseAssignment,
    RefundRequest,
    getRefundRequest,
    getAllUsers,
    updateUserVerifiedStatus,
};

export default AdminApi;